import { TDropItem } from 'src/types';

export const processStatusOptions: TDropItem[] = [
  { value: 'submitted', label: 'Ready to Process' },
  { value: 'processing', label: 'Under Review' },
  { value: 'reopen', label: 'Waiting for user to resubmit info' },
  { value: 'rejected', label: 'Rejected' },
  { value: 'appeal', label: 'Pending Appeal' },
  { value: 'international', label: 'Pending International' },
  { value: 'testSecurity', label: 'Pending Test Security' },
  { value: 'opsApproved', label: 'Vetting Approved' },
  { value: 'completed', label: 'Completed' },
];
